var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h9.429v7.467H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.429 0v1.067H22V0H9.429Zm0 2.133V3.2H22V2.133H9.429Zm0 2.134v1.066H22V4.267H9.429Zm0 2.133v1.067H22V6.4H9.429ZM0 8.533V9.6h22V8.533H0Zm0 2.134v1.066h22v-1.066H0ZM0 12.8v1.067h22V12.8H0Zm0 2.133V16h22v-1.067H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.047 1.067v1.066h1.047V1.067H1.047Zm2.095 0v1.066H4.19V1.067H3.142Zm2.095 0v1.066h1.048V1.067H5.237Zm2.096 0v1.066H8.38V1.067H7.333ZM6.285 2.133V3.2h1.048V2.133H6.285Zm-2.095 0V3.2h1.047V2.133H4.19Zm-2.096 0V3.2h1.048V2.133H2.094ZM1.047 3.2v1.067h1.047V3.2H1.047Zm2.095 0v1.067H4.19V3.2H3.142Zm2.095 0v1.067h1.048V3.2H5.237Zm2.096 0v1.067H8.38V3.2H7.333ZM1.047 5.333V6.4h1.047V5.333H1.047Zm2.095 0V6.4H4.19V5.333H3.142Zm2.095 0V6.4h1.048V5.333H5.237Zm2.096 0V6.4H8.38V5.333H7.333ZM6.285 4.267v1.066h1.048V4.267H6.285Zm-2.095 0v1.066h1.047V4.267H4.19Zm-2.096 0v1.066h1.048V4.267H2.094Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.850be8023e82081317a86b945804e34e.svg";
export { ForwardRef as ReactComponent };